import _findIndex from 'lodash/findIndex';

import editFullAttendanceTemplate from './../edit-full-attendance/edit-full-attendance.html';
import viewAttendanceTemplate from './../view-attendance/view-attendance.html';

export default class ViewAttendancesController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, $timeout, $interval,
    attendances, dialogRender, student, me, moment, categoriesOfDeparture,
    uiCalendarConfig,
    AttendanceService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.attendances = attendances;
    this.dialogRender = dialogRender;
    this.student = student;
    this.me = me;
    this.moment = moment;
    this.categoriesOfDeparture = categoriesOfDeparture;
    this.uiCalendarConfig = uiCalendarConfig;
    this.AttendanceService = AttendanceService;

    dialogRender.callback = (path, val) => {
      if (path === 'isRendered' && val) {
        this.renderCalendar();
      }
    };

    this.events = [];
    this.eventSources = [];

    this.uiConfig = {
      calendar: {
        height: 600,
        lang: 'pl',
        locale: 'pl',
        minTime: '06:00:00',
        maxTime: '22:00:00',
        timeFormat: 'HH:mm',
        allDaySlot: true,
        allDayText: 'Aktualna obecność',
        slotLabelFormat: 'HH:mm',
        slotDuration: '00:15:00',
        defaultDate: this.moment(),
        defaultView: 'month',
        handleWindowResize: false,
        aspectRatio: 1,
        header: {
          left: 'title',
          center: 'month agendaWeek',
          right: 'today prev,next'
        },
        weekends: true,
        eventRender: (event, element) => {
          if (event.endTime) {
            element.attr('title', event.title);
          } else {
            element.attr('title', 'Frekwencja otwarta od: ' + event.title);
          }
        },
        eventClick: (calEvent, jsEvent) => {
          if (!calEvent.endTime) {
            return this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {
                  error: {
                    MessagePL: 'Nie można edytować frekwencji',
                    Errors: ['Wybrany uczeń jest zarejestrowany w świetlicy. Aby wyrejestrować ucznia, przejdź do widoku "Tablica" i wyrejestruj ucznia.']
                  }
                }
              })
            );
          }

          if (Number(calEvent.employeeId) === this.me.employeeId && calEvent.endTime) {
            this.AttendanceService.get(this.student.id, calEvent.id).then(attendance => {
              this.openDialog(calEvent, attendance, editFullAttendanceTemplate, jsEvent);
            });
          } else if (calEvent.additionalInfo.registeredBy.userId === this.me.userId && calEvent.endTime) {
            this.AttendanceService.get(this.student.id, calEvent.id).then(attendance => {
              this.openDialog(calEvent, attendance, viewAttendanceTemplate, jsEvent);
            });
          } else if (calEvent.additionalInfo.deregisteredBy && calEvent.additionalInfo.deregisteredBy.userId === this.me.userId && calEvent.endTime) {
            this.AttendanceService.get(this.student.id, calEvent.id).then(attendance => {
              this.openDialog(calEvent, attendance, viewAttendanceTemplate, jsEvent);
            });
          } else {
            return this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {
                  error: {
                    MessagePL: 'Nie można edytować frekwencji',
                    Errors: [`Wybrany wpis został dodany przez pracownika: ${calEvent.employee.fullName}.`]
                  }
                }
              })
            );
          }
        }
      }
    };
    this.loadAllEvents();
  }

  renderCalendar() {
    if (angular.isUndefined(this.uiCalendarConfig.calendars.mainCalendar)) {
      this.$interval(() => {
        this.uiCalendarConfig.calendars.mainCalendar.fullCalendar('render');
        this.renderCalendar();
      }, 300);
    } else {
      this.uiCalendarConfig.calendars.mainCalendar.fullCalendar('render');
    }
  }

  loadAllEvents() {
    this.eventSources.splice(0, this.eventSources.length);
    this.events = this.attendances.filter(attendance => !attendance.invalid);
    this.invalidEvents = this.attendances.filter(attendance => attendance.invalid);
    this.eventSources.push(
      {
        events: this.invalidEvents,
        color: '#D32F2F'
      },
      {
        events: this.events
      }
    );
  }

  /*
    @param calEvent - calendar event
    @param attendance - attendance related with calendar event
    @param template - dialog template
    @param jsEvent - click event
  */
  openDialog(calEvent, attendance, template, jsEvent) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditFullAttendanceController',
      locals: {attendance: attendance[0], categoriesOfDeparture: this.categoriesOfDeparture},
      template,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: jsEvent,
      multiple: true
    })
      .then(result => {
        const index = _findIndex(this.attendances, attendance => attendance.id === result.id);
        if (index !== -1) {
          this.AttendanceService.get(this.student.id, calEvent.id).then(result => {
            this.attendances[index] = result[0];
            this.loadAllEvents();
          });
        }
      });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
